import React from 'react';

import { POStatusPill } from '@prizeout/prizeout-ui';
import { getStatusColor } from '../../../../../utils';

interface RewardStatusProps {
    status: string;
}

export const RewardStatus: React.FC<RewardStatusProps> = ({ status }): React.ReactElement => {
    return <POStatusPill color={getStatusColor(status)} text={status} />;
};
